import { render, staticRenderFns } from "./addPeopleInfo.vue?vue&type=template&id=c8f9574c&scoped=true&"
import script from "./addPeopleInfo.vue?vue&type=script&lang=ts&"
export * from "./addPeopleInfo.vue?vue&type=script&lang=ts&"
import style0 from "./addPeopleInfo.vue?vue&type=style&index=0&id=c8f9574c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8f9574c",
  null
  
)

export default component.exports